// src/pages/LoginScreen.tsx
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { loginHelpers } from "../logic/loginHelpers";
import { validEmail, validPassword } from "../logic/validation";
import styles from "./Login.module.css";
import { Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import { useLocation, useNavigate } from "react-router-dom";
import LoginSection from "../../../components/LoginSection/LoginSection";

export default function LoginScreen(props: any) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoginSuccessfull, setIsLoginSuccessfull] = useState<boolean | null>(
    null
  );
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [loginResponse, setLoginResponse] = useState<any>(null);
  // let redirectUrl = sessionStorage.getItem("redirectUrl") || "/";

  useEffect(() => {
    if (location.state?.successMessage) {
      setSnackbarMessage(location.state.successMessage);
      setSnackbarOpen(true);
    }
  }, [location.state]);

  // In your LoginScreen component

  useEffect(() => {
    if (loginResponse?.success) {
      // Get the saved redirect URL (includes workspace param if it was in the original URL)
      const redirectUrl = sessionStorage.getItem("redirectUrl") || "/";

      // Clean up session storage
      sessionStorage.removeItem("redirectUrl");

      // Ensure token is stored before navigate
      setTimeout(() => {
        navigate(redirectUrl, { replace: true });
      }, 300);
    }
  }, [loginResponse, navigate]);

  const handleSnackbarOpen = () => setSnackbarOpen(true);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const isSuccessLogin = async (body: any) => {
    setIsLoginLoading(true);
    try {
      await loginHelpers.isSuccessLogin(body, {
        dispatch,
        handleSnackbarOpen,
        setSnackbarMessage,
        setIsLoginSuccessfull,
        setLoginResponse,
        navigate,
      });
    } finally {
      setIsLoginLoading(false);
    }
  };

  const loginNow = async (email: string, password: string) => {
    const result = await isSuccessLogin({ email, password });
    return result;
  };

  const loginProps = {
    isSuccessLogin,
    props,
    dispatch,
    loginNow,
    isValidEmail: validEmail,
    validPassword,
    isLoginSuccessfull,
    isLoginLoading,
    loginResponse,
    snackbarMessage,
    setLoginResponse,
    navigate,
  };

  return (
    <div className={styles.x1080empty}>
      <img
        className={styles.backgroundImage1}
        alt="Background"
        src="/background-image-1@2x.png"
      />
      <section className={styles.whiteSection}>
        <LoginSection {...loginProps} />
      </section>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleSnackbarClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={location.state?.successMessage ? "success" : "error"}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
